import { createReducer, on } from '@ngrx/store';

import {
  setListEditClickedFromLookbook,
  setLookbookIdInRouter,
  setLookbookListIdInRouter,
} from './shop-the-look-core.actions';

export interface CoreShopTheLookState {
  lookbookIdInRouter?: string;
  lookbookListIdInRouter?: string;
  listEditClickedFrom?: {
    lookbookId: string;
    listId: string;
  };
}

export const initial: CoreShopTheLookState = {};

export const coreShopTheLookReducer = createReducer(
  initial,
  on(setLookbookIdInRouter, (state, { lookbookId }) => ({
    ...state,
    lookbookIdInRouter: lookbookId,
  })),
  on(setLookbookListIdInRouter, (state, { lookbookListId }) => ({
    ...state,
    lookbookListIdInRouter: lookbookListId,
  })),
  on(setListEditClickedFromLookbook, (state, { listEditClickedFrom }) => ({
    ...state,
    listEditClickedFrom,
  })),
);
